import { eMode } from "../../../content/enum";
import { IDmMucHoTroNhaNuocSelectRequest } from "../../../model/respone/category/IDmMucHoTroNhaNuoc";
import { IDmMucHoTroNhaNuocActionTypes } from "../../action-types/category/IDmMucHoTroNhaNuocActions";
import { IDmMucHoTroNhaNuocReducer } from "../../reducer-model/category/IDmMucHoTroNhaNuocReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const iniState: IDmMucHoTroNhaNuocReducer = {
  status: eReducerStatusBase.is_not_initialization,
  mucHoTroNhaNuocs: [],
  mode: eMode.xem,
  isShowCopyModal: false,
  requestCopy: {},
  expandedKeys: [],
  request: {
    hoc_ky: 0,
    nam_hoc: "",
    id_he: 0,
    khoa_hoc: 0,
  } as IDmMucHoTroNhaNuocSelectRequest,
};

export const mucHoTroNhaNuocReducer = (
  state: IDmMucHoTroNhaNuocReducer = iniState,
  action: IDmMucHoTroNhaNuocActionTypes,
): IDmMucHoTroNhaNuocReducer => {
  switch (action.type) {
    case "MUC_HO_TRO_NHA_NUOC_UPDATE_STATUS":
      return { ...state, status: action.payload };
    case "MUC_HO_TRO_NHA_NUOC_LOAD_START":
      return { ...state, status: eReducerStatusBase.is_loading };
    case "MUC_HO_TRO_NHA_NUOC_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        mucHoTroNhaNuocs: action.payload,
      };
    case "MUC_HO_TRO_NHA_NUOC_LOAD_ERROR":
      return { ...state, status: eReducerStatusBase.is_completed };
    case "MUC_HO_TRO_NHA_NUOC_SAVE_MULTIPLE_START":
      return { ...state, status: eReducerStatusBase.is_saving };
    case "MUC_HO_TRO_NHA_NUOC_SAVE_MULTIPLE_SUCCESS":
      // Lưới TỰ LƯU mỗi lần rời ô, nên KHÔNG nạp lại và KHÔNG thoát chế độ Sửa: nạp lại sẽ
      // giật lưới và xóa số đang gõ dở, còn thoát chế độ Sửa thì gõ được đúng một ô.
      // Giá trị hiển thị vẫn đúng vì lưới giữ số vừa gõ tới khi bấm Làm mới.
      return { ...state, status: eReducerStatusBase.is_saved };
    case "MUC_HO_TRO_NHA_NUOC_SAVE_MULTIPLE_ERROR":
      return { ...state, status: eReducerStatusBase.is_completed };
    case "MUC_HO_TRO_NHA_NUOC_SHOWHIDE_COPY_MODAL":
      return {
        ...state,
        isShowCopyModal: action.payload,
        // Đóng modal thì xóa luôn lựa chọn nguồn, lần sau mở ra không dính số cũ.
        requestCopy: action.payload ? state.requestCopy : {},
      };
    case "MUC_HO_TRO_NHA_NUOC_COPY_CHANGE_REQUEST":
      return { ...state, requestCopy: { ...state.requestCopy, ...action.payload } };
    case "MUC_HO_TRO_NHA_NUOC_COPY_START":
      return { ...state, status: eReducerStatusBase.is_saving };
    case "MUC_HO_TRO_NHA_NUOC_COPY_SUCCESS":
      // Chép xong PHẢI nạp lại: dữ liệu kỳ đang xem vừa bị ghi đè.
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowCopyModal: false,
        requestCopy: {},
      };
    case "MUC_HO_TRO_NHA_NUOC_COPY_ERROR":
      return { ...state, status: eReducerStatusBase.is_completed };
    case "MUC_HO_TRO_NHA_NUOC_CHANGE_REQUEST":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        request: { ...state.request, ...action.payload },
      };
    case "MUC_HO_TRO_NHA_NUOC_CHANGE_MODE":
      return { ...state, mode: action.payload };
    case "MUC_HO_TRO_NHA_NUOC_SET_EXPANDED_KEYS":
      return { ...state, expandedKeys: action.payload };
    default:
      return state;
  }
};
